export default __webpack_public_path__ + "static/media/Inspiration.b3af20e5.png";